/* @jsxImportSource react */

import * as React from 'react';

const PriceOldPrice = ({
  children,
  ...props
}: React.HTMLAttributes<Omit<HTMLSpanElement, 'className'>>) => (
  <span
    className="price-old-price text-size-body3 text-color-text-dark inline-flex grow-0 items-center justify-start empty:hidden"
    {...props}
  >
    {children}
  </span>
);

PriceOldPrice.displayName = 'Price.OldPrice';

export { PriceOldPrice };
